<template>
    <v-dialog
        v-model="open"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        persistent
    >
        <v-card class="document-preview-dialog">
            <v-toolbar dark color="success" class="document-preview-toolbar">
                <v-toolbar-title class="white--text">
                    {{ name || "Document" }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    v-if="url"
                    color="default"
                    dark
                    class="mr-2"
                    :href="url"
                    target="_blank"
                    rel="noopener"
                >
                    Open in new tab
                </v-btn>
                <v-btn color="default" dark @click="close">Close</v-btn>
            </v-toolbar>
            <div class="document-preview-content">
                <img
                    v-if="kind === 'image'"
                    class="document-preview-image"
                    :src="url"
                    :alt="name"
                />
                <div
                    v-else-if="kind === 'pdf' || kind === 'other'"
                    class="document-preview-frame-wrap"
                >
                    <iframe
                        class="document-preview-frame"
                        :src="previewUrl"
                    ></iframe>
                </div>
                <div v-else-if="kind === 'audio'" class="document-preview-audio-wrap">
                    <v-icon size="64" color="#90a4ae">mdi-file-music</v-icon>
                    <audio class="mt-4" controls :src="url"></audio>
                </div>
                <video
                    v-else-if="kind === 'video'"
                    class="document-preview-video"
                    controls
                    :src="url"
                ></video>
            </div>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    name: "DocumentPreviewDialog",
    props: {
        value: Boolean,
        url: String,
        name: String,
        kind: String,
    },
    computed: {
        open: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
        previewUrl() {
            if (!this.url) {
                return "";
            }

            if (this.kind === "pdf" && this.url.indexOf("#") === -1) {
                return this.url + "#toolbar=0&navpanes=0&view=FitH";
            }

            return this.url;
        },
    },
    methods: {
        close() {
            this.open = false;
        },
    },
};
</script>
<style>
.document-preview-dialog {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

.document-preview-toolbar {
    flex: 0 0 auto;
}

.document-preview-content {
    flex: 1 1 auto;
    background: #37474f;
    min-height: calc(100vh - 64px);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: auto;
}

.document-preview-frame-wrap {
    width: 100%;
    min-height: calc(100vh - 64px);
    padding: 16px;
    box-sizing: border-box;
}

.document-preview-frame {
    display: block;
    width: 100%;
    height: calc(100vh - 96px);
    border: 0;
    border-radius: 6px;
    background: #fff;
    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.35);
}

.document-preview-image,
.document-preview-video {
    display: block;
    max-width: calc(100% - 32px);
    max-height: calc(100vh - 96px);
    margin: 16px auto;
    border-radius: 6px;
    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.35);
}

.document-preview-audio-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #fff;
}
</style>
